import tippy from "tippy.js";

// To add a tooltip add the `tippy-content` data property
//
// <button data-tippy-content="Tooltip">Text</button>

import { topLayerOptions } from "./lib/top_layer_tooltip";

export function initializeTooltips(root) {
  // Tippy: plain text
  tippy(
    root.querySelectorAll(
      "[data-tippy-content]:not([data-tippy-html-content])",
    ),
    topLayerOptions,
  );

  // Tippy: HTML content
  tippy(
    root.querySelectorAll("[data-tippy-content][data-tippy-html-content]"),
    {
      ...topLayerOptions,
      allowHTML: true,
      duration: [80, 50],
    },
  );

  // Bootstrap tooltips
  Array.from(root.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach(
    (el) => new (window.bootstrap?.Tooltip || window.Tooltip)(el),
  );

  // Tippy: scope tooltips (lazy — builds HTML from JSON on hover)
  Array.from(root.querySelectorAll("[data-scope-tip]")).forEach((el) => {
    tippy(el, {
      ...topLayerOptions,
      content(ref) {
        const data = JSON.parse(ref.getAttribute("data-scope-tip"));
        const esc = (s) => {
          const d = document.createElement("div");
          d.textContent = s;
          return d.innerHTML;
        };
        let html = '<div class="p-1">';
        if (data.projects) {
          html +=
            '<div class="c-scope-tip-header">Projects</div><div class="mb-2">';
          data.projects.forEach((p) => {
            html += `<div class="c-scope-tip-project">${esc(p)}</div>`;
          });
          html += "</div>";
        }
        if (data.projects)
          html += '<div class="c-scope-tip-header">Scopes</div>';
        html += '<div class="d-flex flex-wrap gap-1">';
        data.scopes.forEach((s) => {
          html += `<span class="badge rounded-pill c-scope-badge">${esc(s)}</span>`;
        });
        html += "</div></div>";
        return html;
      },
      allowHTML: true,
      duration: [80, 50],
    });
  });

  // Tippy: template-based
  Array.from(root.querySelectorAll("[data-tippy-template]")).forEach((el) => {
    tippy(el, {
      ...topLayerOptions,
      content(ref) {
        const id = ref.getAttribute("data-tippy-template");
        const tpl = root.querySelector(id) || document.querySelector(id);
        return tpl ? tpl.innerHTML : "";
      },
      allowHTML: true,
      duration: [80, 50],
      interactive: el.hasAttribute("data-tippy-interactive"),
    });
  });
}

$(document).on("turbo:load turbo:frame-render", function () {
  initializeTooltips(document);
});

/**
 * Re-initialize tooltips after Turbo Stream updates.
 * Overrides the render function so we can run code after DOM mutation.
 * Skips "remove" actions. Uses the stream target id to find the updated node.
 */
document.addEventListener("turbo:before-stream-render", (event) => {
  const origRender = event.detail.render;

  event.detail.render = function (streamEl) {
    const action = streamEl.getAttribute("action");
    if (action === "remove") return;
    const id = streamEl.getAttribute("target");
    origRender(streamEl);
    initializeTooltips(document.getElementById(id) || document);
  };
});
